module.exports = __webpack_public_path__ + "img/dictionary-purple.80efa07d.svg";